import React, { useCallback, useRef, useEffect } from 'react'
import classNames from 'classnames'

import MUITooltip, { TooltipProps as MUITooltipProps } from '@material-ui/core/Tooltip'
import classes from './Tooltip.scss'

type TooltipProps = MUITooltipProps & Partial<{
  isLight: boolean
  enabled: boolean
  delayedOpenTimeout: number | false
  onDelayedOpen: (event: React.ChangeEvent) => void
  onOpen: (event: React.ChangeEvent) => void
  onClose: (event: React.ChangeEvent) => void
}>

export default function Tooltip({
  isLight = false,
  enabled = true,
  delayedOpenTimeout = false,
  onDelayedOpen = null,
  onOpen = null,
  onClose = null,
  title = '',
  children = <></>,
  ...rest
}: TooltipProps) {
  const timeoutRef = useRef(null)

  const onOpenCallback = useCallback(evt => {
    if (delayedOpenTimeout && onDelayedOpen) {
      timeoutRef.current = setTimeout(() => {
        onDelayedOpen(evt)
      }, delayedOpenTimeout)
    }

    if (onOpen) {
      onOpen(evt)
    }
  }, [delayedOpenTimeout, onDelayedOpen, onOpen])

  const onCloseCallback = useCallback(evt => {
    if (onDelayedOpen) {
      clearTimeout(timeoutRef.current)
    }

    if (onClose) {
      onClose(evt)
    }
  }, [onClose, onDelayedOpen])

  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current)
    }
  }, [])

  return (
    <MUITooltip
      classes={{
        tooltip: classNames({
          [classes.light]: isLight
        })
      }}
      onOpen={onOpenCallback}
      onClose={onCloseCallback}
      title={title}
      {...rest}
    >
      {children}
    </MUITooltip>
  )
}
